module.exports = __webpack_public_path__ + "static/img/goalkeeper.c8d72912.svg";